<template>
  <section class="tw:bg-white tw:flex-1">
    <ContainerLayout>
      <div class="tw:py-[60px] tw:flex tw:w-full tw:flex-col tw:md:max-w-screen-md">
        <div class="tw:flex tw:flex-col">
          <h2
            class="tw:text-[28px] tw:leading-[35px] tw:md:text-[32px] tw:md:leading-[40px] tw:mb-8 tw:text-center"
            v-html="$t('rc_eligibility_faq_header')"
          />

          <FaqLinksList :items="faq" singleColumn />
        </div>
      </div>
    </ContainerLayout>
  </section>
</template>
<script setup>
import { computed } from 'vue'
import FaqLinksList from '@/components/productPage/FaqLinksList.vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'

const props = defineProps({
  isBlockedCountry: Boolean,
})
const faq = computed(() =>
  props.isBlockedCountry
    ? [
        {
          key: 'rc_ineligible_faq_1',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Why-your-property-is-listed-on-trivago',
        },
        {
          key: 'rc_ineligible_faq_2',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-to-upload-photos-to-your-profile',
        },
        {
          key: 'rc_ineligible_faq_3',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=performance-analytics-explained',
        },
      ]
    : [
        {
          key: 'rc_eligible_faq_1',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Requirements-to-start-Rate-Connect',
        },
        {
          key: 'rc_eligible_faq_2',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=How-Rate-Connect-s-pay-per-stay-campaign-works',
        },
        {
          key: 'rc_eligible_faq_3',
          url: 'https://trivago.my.site.com/trivagoSupport/help?articleUrl=Time-required-for-website-rates-to-go-live-with-Rate-Connect',
        },
      ]
)
</script>
